import { DefaultValue } from 'recoil';
import * as hashLocalStorage from './hashLocalStorage';

export const localStorageEffect =
  (options: { key: string; restorer: (arg0: any, arg1: DefaultValue) => any }) =>
  ({ setSelf, onSet }: any) => {
    const savedValue = hashLocalStorage.getItem(options.key);

    if (savedValue != null) {
      setSelf(options.restorer(savedValue, new DefaultValue()));
    }

    onSet((newValue: any) => {
      if (newValue instanceof DefaultValue) {
        hashLocalStorage.removeItem(options.key);
      } else {
        hashLocalStorage.setItem(options.key, newValue);
      }
    });
  };
